module.exports = __webpack_public_path__ + "static/media/icon_accept.1f14a014.svg";